<template>
    <div class="content_box mobile_content">
        <div class="content permission">
            <div class="title_box">
                <div class="title_name">
                    <span class="title">{{`角色名称：${$route.query.role_name}`}}</span>
                </div>
            </div>
            <div class="permission_box">
                <div class="p_table">
                    <div class="p_table_content p_table_tbody">
                        <div class="level_1">
                            <div class="name level_1_name">一级</div>
                            <div class="level_2">
                                <div class="page">
                                    <div class="name level_2_name">二级</div>
                                    <div class="level_3">
                                        <div class="name">功能操作权限  </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="p_table_content" v-for="(val, v_key) in permissionData" :key="val.id + '2124'">
                        <div class="level_1">
                            <div class="name level_1_name" @click="selectLevel1(v_key)">
                                <div class="checkbox" :class="level[v_key] ? 'select' : ''">
                                    <i class="el-icon-check"></i>
                                </div>
                                <span>{{val.name}}</span>
                            </div>
                            <div class="level_2" >
                                <template v-for="(menu,m_key) in val.menu">
                                    <div class="page" v-for="(pages, s_key) in menu.pages" :key="pages.path + '2313311'">
                                        <div class="name level_2_name" @click="selectLevel2(v_key + '-' + m_key + '-' + s_key)">
                                            <div class="checkbox" :class="level[v_key] && level[v_key][v_key + '-' + m_key + '-' + s_key] && level[v_key][v_key + '-' + m_key + '-' + s_key].length > 0 ? 'select' : ''">
                                                <i class="el-icon-check"></i>
                                            </div>
                                            <span>{{pages.name}}</span>
                                        </div>
                                        <div class="level_3" >
                                            <template v-for="(p, p_key) in pages.permission">
                                                <div class="name" @click="selectLevel3(v_key, (v_key + '-' + m_key + '-' + s_key), p_key)">
                                                    <div class="checkbox" :class="level[v_key] && level[v_key][v_key + '-' + m_key + '-' + s_key] && level[v_key][v_key + '-' + m_key + '-' + s_key].indexOf(p_key) != -1 ? 'select' : ''" >
                                                        <i class="el-icon-check"></i>
                                                    </div>
                                                    <span>{{p.name}}</span>
                                                </div>
                                            </template>
                                        </div>
                                    </div>
                                </template>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="act_box">
                <div class="button cancel" @click="$router.push({name: 'role'})">取消</div>
                <div class="button" @click="save">保存</div>
                <div class="button" @click="$router.push({name: 'permission-upload'})">权限文件上传</div>
            </div>
        </div>
    </div>
    
</template>
<script>
import Nav from '../../../static/nav/nav.json'
export default({
    name: 'permission',
    data() {
        return {
            permissionData: {},
            permission: [],
            level: {}
        }
    },
    created() {
        this.permissionData = Nav;
    },
    activated () {
        if(!this.$route.query.role_id) {
            this.$router.go(-1);
            return;
        }
        this.getRolePermission();
    },
    methods: {
        selectLevel1(key) {  //点击一级
            if(this.level[key]) {  //已存在key，说明此操作为取消选中
                this.$delete(this.level, key)
            }else{  //选中一级   二级三级同时选上
                this.$set(this.level, key, {});
                for (const k1 in this.permissionData[key].menu) {
                    for (const k2 in this.permissionData[key].menu[k1].pages) {
                        this.$set(this.level[key], key + '-' + k1 + '-' + k2, []);
                        for (const k3 in this.permissionData[key].menu[k1].pages[k2].permission) {
                            this.level[key][key + '-' + k1 + '-' + k2].push(k3);
                        }
                    }
                }
            }
        },
        selectLevel2(key) {  //点击二级
            let k = key.split('-');
            if(this.level[k[0]]){ //已存在一级key
                if(this.level[k[0]][key]) { //已存在二级key，说明此操作为取消选中
                    this.$delete(this.level[k[0]], key);
                    if(Object.keys(this.level[k[0]]).length == 0) {  //取消选中所有二级,一级同时会取消
                        this.$delete(this.level, k[0]);
                    }
                }else{  //不存在二级，选中二级的同时 选上三级
                    this.$set(this.level[k[0]], key, []);
                    for (const k1 in this.permissionData[k[0]].menu[k[1]].pages[k[2]].permission) {
                        this.level[k[0]][key].push(k1);
                    }
                }
            }else{  //不存在一级key，需要同时勾选上一级
                this.$set(this.level, k[0], {});
                this.$set(this.level[k[0]], key, []);
                for (const k1 in this.permissionData[k[0]].menu[k[1]].pages[k[2]].permission) {
                    this.level[k[0]][key].push(k1);
                }
            }
        },
        selectLevel3(k1,k2,key) { //点击三级
            let k = key.split('-');
            let k3 = key.split('-');
            if(this.level[k1]){ //已存在一级key
                if(this.level[k1][k2]) { //已存在二级key
                    let i = this.level[k1][k2].indexOf(key);
                    if(i != -1){ //已存在三级key,说明此操作为取消选中
                        this.level[k1][k2].splice(i, 1);
                        if(Object.keys(this.level[k1][k2]).length == 0) {  //取消选中所有三级,二级同时会取消
                            this.$delete(this.level[k1], k2);
                            if(Object.keys(this.level[k1]).length == 0) {  //取消选中所有二级,一级同时会取消
                                this.$delete(this.level, k1)
                            }
                        }else if(k[k.length - 1] == '101') { // 101  取消查看功能，会把所有权限取消 
                            this.$delete(this.level[k1], k2);
                            if(Object.keys(this.level[k1]).length == 0) {  //取消选中所有二级,一级同时会取消
                                this.$delete(this.level, k1)
                            }
                        }
                    }else { //存在一级 二级， 不存在 三级
                        this.level[k1][k2].push(key);
                        if(this.level[k1][k2].indexOf(key != k2 + '-101') == -1) {  //没有查看权限，点击其他的权限需要把查看权限选中
                            this.level[k1][k2].push(k3[0] + '-' + k3[1] + '-' + k3[2] + '-101');
                        }
                    }
                }else{ //存在一级 不存在 二级三级
                    this.$set(this.level[k1], k2, [key]);
                    if(this.level[k1][k2].indexOf(key != k2 + '-101') == -1) {  //没有查看权限，点击其他的权限需要把查看权限选中
                        this.level[k1][k2].push(k3[0] + '-' + k3[1] + '-' + k3[2] + '-101');
                    }
                }
            }else{  //不存在一级key，需要同时勾选上一级二级
                this.$set(this.level, k1, {});
                this.$set(this.level[k1], k2, [key]);
                if(this.level[k1][k2].indexOf(key != k2 + '-101') == -1) {  //没有查看权限，点击其他的权限需要把查看权限选中
                    this.level[k1][k2].push(k3[0] + '-' + k3[1] + '-' + k3[2] + '-101');
                }
            }
        },
        getRolePermission() {
            this.api.getPermission({role_id: parseInt(this.$route.query.role_id)}).then(data => {
                this.permission = data.data ? data.data.rule_keys || [] : [];
                this.setPermission();
            }) 
        },
        setPermission() { //根据角色权限数据 初始化页面选中
            this.level = {};
            
            this.permission.forEach(item => {
                let k = item.split('-');
                let k0 = 'n' + k[0];
                let k2 = 'n' + k[0] + '-m' + k[1] + '-p' + k[2];
                if(this.level[k0]){  //已有一级key
                    if(!this.level[k0][k2]) { //没有二级key
                        this.$set(this.level[k0], k2, []);
                    }
                    this.level[k0][k2].push(item);
                }else{
                    this.$set(this.level, k0, {});
                    this.$set(this.level[k0], k2, []);
                    this.level[k0][k2].push(item);
                }
            })
        },
        save() {
            this.permission = [];
            for(let k1 in this.level){
                if(k1) {
                    for(let k2 in this.level[k1]){
                        this.level[k1][k2].forEach(item => {
                            if(this.permission.indexOf(item) == -1) {
                                this.permission.push(item)
                            }
                        })
                    }
                }
                
            }
            if(this.permission.length == 0) {
                this.$message.warning('请选择权限！');
            }else{
                this.api.updatePermission({role_id: parseInt(this.$route.query.role_id), rule_keys: this.permission}).then(data => {
                    this.$message.success('权限修改成功！');
                    this.$router.go(-1);
                })
            }
        }
    }
})
</script>
<style lang="less" scoped>
    .content{
        position: relative;
        .permission_box{
            .p_table{
                border: 1px solid @colorLine;
                font-size: 14px;
                .border_bottom{
                    border-bottom: 1px solid @colorLine;
                }
                .border_left{
                    border-left: 1px solid @colorLine;
                }
                .p_table_content{
                    .level_1{
                        .flexLayout(flex-start);
                        .border_bottom();
                        .name{
                            padding: 12px 0 12px 40px;
                            .flexLayout(flex-start);
                            cursor: pointer;
                            .checkbox{
                                width: 12px;
                                height: 12px;
                                line-height: 12px;
                                border-radius: 2px;
                                border: 1px solid @colorLine;
                                text-align: center;
                                font-size: 12px;
                                color: @colorWhite;
                                margin-right: 10px;
                                &.select{
                                    border-color: @colorBlue2;
                                    background-color: @colorBlue2;
                                }
                            }
                        }
                        .level_1_name{
                            width: 200px;
                        }
                        .level_2{
                            flex: 1;
                            .border_bottom();
                            &:last-child{
                                border-bottom: none;
                            }
                            .page{
                                .flexLayout(flex-start);
                                .border_bottom();
                                .border_left();
                                .level_2_name{
                                    width: 300px;
                                }
                                .level_3{
                                    .border_left();
                                    .flexLayout(flex-start);
                                    flex: 1;
                                }
                                &:last-child{
                                    border-bottom: none;
                                }
                            }
                        }
                    }
                    &.p_table_tbody{
                        background-color: #F7F8FA;
                        font-weight: 600;
                        text-align: center;
                        .level_1{
                            .page{
                                border-bottom: none!important;
                                .level_3{
                                    display: block!important;
                                }
                            }
                        }
                        
                    }
                    &:last-child{
                        .level_1{
                            border-bottom: none;
                        }
                    }
                }
            }
            @media (max-width: 768px) {
                width: 100%;
                overflow: auto;
                .p_table{
                    min-width: 1200px;
                }
            }
        }
        .act_box{
            .flexLayout();
            padding-top: 30px;
            box-sizing: border-box;
            .button{
                margin: 0 10px;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/view/settings/permission.vue